import {inject, Injectable} from '@angular/core';
import {PaymentGateway} from '@features/payment/domain/model/payment.model';
import {
  PaymentStrategy,
  PaymentStrategyRegistry
} from '@features/payment/domain/ports/strategy/payment-strategy.port';
import {OnlineCloudStrategy} from '../strategies/payment/online-cloud.strategy';
import {HardwareIntegratedStrategy} from '../strategies/payment/hardware-integrated.strategy';
import {OfflineQueueStrategy} from '../strategies/payment/offline-queue.strategy';
import {WalletSettlementStrategy} from '../strategies/payment/wallet-settlement.strategy';

@Injectable({providedIn: 'root'})
export class InfrastructurePaymentStrategyRegistry implements PaymentStrategyRegistry {
  private readonly onlineCloud = inject(OnlineCloudStrategy);
  private readonly offlineQueue = inject(OfflineQueueStrategy);
  private readonly walletSettlement = inject(WalletSettlementStrategy);
  private readonly hardwareIntegrated = inject(HardwareIntegratedStrategy);

  resolve(gateway: PaymentGateway): PaymentStrategy {
    if (gateway === PaymentGateway.API || gateway === PaymentGateway.TERMINAL) {
      return this.onlineCloud;
    }

    if (gateway === PaymentGateway.TAP_TO_PAY) {
      return this.hardwareIntegrated;
    }

    if (gateway === PaymentGateway.WALLET) {
      return this.walletSettlement;
    }

    if (gateway === PaymentGateway.CUSTOMER) {
      return this.offlineQueue;
    }

    throw new Error(`[PaymentStrategyRegistry] No strategy found for gateway: ${gateway}`);
  }
}
